<section class="cmn-innerpage-wrapper client-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button class="cmn-add-btn" (click)="navigateTo('/refund/refund-new')" *ngIf="canCreateRefund$ | async">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Refund
    </button>
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Refunds</li>
      <!-- <li class="edit" (click)="onEdit()">
        <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit Icon" />
        Edit
      </li> -->
      <li *ngIf="refundDetails?.refundStatus === 'Approved'" class="edit" (click)="onViewDocument()">
        <img src="assets/images/icons/icon-pdf.svg" alt="PDF" />
        PDF
      </li>
    </ul>
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          class="tab-custom-button"
          *ngFor="let refund of allRefunds; let i = index"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>{{ refund?.customerData?.firstName + " " + refund?.customerData?.lastName }}</h2>
            <h6>
                {{
                  refund?.amount == null ||
                  refund?.amount === 0
                    ? "AED 0.00"
                    : "AED " + refund.amount.toFixed(2)
                }}
              </h6>
            <h6>{{ refund?.refundStatus }}</h6>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div>
        <div class="common-noimage-tab-wrapper">
          <mat-tab-group animationDuration="0ms">
            <!-- Mat Tab One -->
            <mat-tab>
              <ng-template mat-tab-label>
                <h2 class="leave-tab-title">Overview</h2>
              </ng-template>
              <div class="client-cmn-inner-content-wrapper">
                <div class="overview-main-wrapper">
                  <div class="content">
                    <h2>
                      {{
                        refundDetails?.customerData?.firstName +
                          " " +
                          refundDetails?.customerData?.lastName
                      }}
                    </h2>
                  </div>
                  <div class="client-details-overview-wrapper">
                    <div class="details-wrapper">
                      <h2>Invoice Number</h2>
                      <h3>{{ refundDetails?.invoiceData?.invoiceNo }}</h3>
                    </div>
                    <div class="details-wrapper">
                      <h2>Refund Amount</h2>
                      <h3>
                        {{
                          refundDetails?.amount == null || refundDetails?.amount === 0
                            ? "AED 0.00"
                            : "AED " + refundDetails.amount.toFixed(2)
                        }}
                      </h3>
                    </div>
                    <div class="details-wrapper">
                      <h2>Refund Date</h2>
                      <h3>{{ refundDetails?.refundDate | date : "dd/MM/YYYY" }}</h3>
                    </div>
                    <div class="details-wrapper">
                      <h2>Reference Number</h2>
                      <h3>{{ refundDetails?.referenceNumber }}</h3>
                    </div>
                    <div class="details-wrapper">
                      <h2>Payment Method</h2>
                      <h3>{{ refundDetails?.paymentMethod }}</h3>
                    </div>
                    <ng-container *ngIf="refundDetails?.isCheque">
                      <div class="details-wrapper">
                        <h2>Cheque No</h2>
                        <h3>{{ refundDetails?.chequeNo }}</h3>
                      </div>
                      <div class="details-wrapper">
                        <h2>Cheque Date</h2>
                        <h3>{{ refundDetails?.chequeDate | date : "dd/MM/YYYY" }}</h3>
                      </div>
                    </ng-container>
                
                    <div class="details-wrapper">
                      <h2>Refund status</h2>
                      <h3>{{ refundDetails?.refundStatus }}</h3>
                    </div>
                  </div>
                
                  <div *ngIf="refundDetails?.refundStatus === 'Pending' && (canApproveRejectRefund$ | async)" class="invoice-details-footer-wrapper">
                    <div class="submit-btn-wrapper">
                      <button class="cmn-next-btn" (click)="handleApproval(true)" type="button">Approve</button>
                      <button class="cmn-next-btn"  (click)="handleApproval(false)" type="button">Reject</button>
                    </div>
                  </div>
                </div>
                
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>
